module.exports = __webpack_public_path__ + "img/big_1_14.e3cd9721.png";